import { Component, Input, OnInit } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { catchError } from 'rxjs';
import { CommonModelPopUpComponent } from 'src/app/components/common-model-pop-up/common-model-pop-up.component';
import { AddEditMailingListComponent } from 'src/app/components/list-manager/Pop-up/add-edit-mailing-list/add-edit-mailing-list.component';
import { DeletePageType, PopUpTitles, TabNames } from 'src/app/shared/model/enum';
import { AgGridService } from '../ag-grid.service';
import { ListManagerService } from 'src/app/components/list-manager/list-manager.service';
import { ToastrService } from 'ngx-toastr';
import { Result } from 'src/app/shared/model/response.model';
import { Router } from '@angular/router';
import { CategoryService } from 'src/app/shared/services/category.service';

@Component({
  selector: 'app-svg-renderer',
  templateUrl: './svg-renderer.component.html',
  styleUrls: ['./svg-renderer.component.scss']
})
export class SvgRendererComponent implements OnInit, ICellRendererAngularComp {
  params: any;
  response :string;
  @Input() buttonName: string;
  deletePageType = DeletePageType;
  @Input() isVisible: boolean = true;
  currentTab = ''
  enumTabNames            = TabNames;

  constructor(public modalService: NgbModal,
    public agGridService: AgGridService,
    public listManagerService :ListManagerService,
    private router :Router,
    public  categoryService: CategoryService, 

  ) { }
  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
  }
  refresh(params: ICellRendererParams<any, any>): boolean {
    return false;
  }

  ngOnInit(): void {
    this.router.url
  }
  openEditModalTemplate(id){
    //this.router.navigate(['/smxquilleditor'], { queryParams: { id: id } }); 
   // this.router.navigate(['/smxeditor'], { queryParams: { id: id } });  //   this.categoryService.getTemplateById(id).subscribe(data =>{
  
  }



  saveEditorContent(id: string, content: any) {
      this.categoryService.getTagsByCategoryId
  }


handleError(err: any): any {
  console.log(err);
}

handleEditIconClick(params): void {
  params?.api?.deselectAll();
  //  params?.node?.setSelected(true);
  const customEvent = new CustomEvent('editIconClick', {
    detail: { data: params },
  });
  // this.params?.api?.dispatchEvent(customEvent);
  //window.dispatchEvent(customEvent);
  document.dispatchEvent(customEvent); 
 }

 handleDeleteIconClick (params) : void {
  params?.api?.deselectAll();
  const customEvent = new CustomEvent('deleteIconClick', {
    detail: { data: params },
  });
  document.dispatchEvent(customEvent); 
 }


}

